/** Map the current new-site path to the closest old-site path (no host). */
export function oldPathFromNewPathname(pathname: string): string {
  const path = normalize(pathname.replace(/^\/new(?=\/|$)/, '') || '/');

  if (path === '/login' || path.endsWith('/login')) return '/login';
  if (path === '/register' || path.endsWith('/register')) return '/register';
  if (path.includes('forgot-password')) return '/forgot-password';
  if (path.includes('renew-forgotten-password')) return '/renew-forgotten-password';

  if (path.includes('/management/support-requests')) return '/supports/manage';
  if (path.includes('/management/funds')) return '/funds/manage';
  if (path.includes('/management/open-fund-requests')) return '/funds/open-fund-requests-list';
  if (path.includes('/management/users')) return '/admin/manage-users';
  if (path.includes('/management/transactions-inquiry')) return '/transactions-inquiry';

  if (path.includes('/open-fund/community')) return '/funds/open-community-fund-form';
  if (path.includes('/open-fund/kollel')) return '/funds/open-kollel-fund-form';
  if (path.includes('/open-fund/welfare')) return '/funds/open-welfare-fund-form';

  if (path.includes('/support/support-requests')) return '/supports/list-support-requests-all';
  if (path.includes('/support/supporteds')) return '/supports/update-fund';
  if (path.includes('/standing-orders')) return '/debits';
  if (path.includes('/bank-standing-orders')) return '/debits';
  if (path.includes('/transactions')) return '/transactions';

  return '/transactions';
}

export function buildOldSiteUrl(oldBase: string, newPathname: string): string {
  const base = oldBase.replace(/\/$/, '');
  const path = oldPathFromNewPathname(newPathname);
  const sep = path.includes('?') ? '&' : '?';
  return `${base}${path}${sep}from=new`;
}

function normalize(path: string): string {
  const withSlash = path.startsWith('/') ? path : `/${path}`;
  return withSlash.length > 1 ? withSlash.replace(/\/+$/, '') : withSlash;
}
